// Subscribe.jsx
import React from "react";
import styled from "styled-components";

const Card = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 12px;
  max-width: 600px;
  width: 100%;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  text-align: center;
`;

const Heading = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
`;

const Subtext = styled.p`
  font-size: 0.95rem;
  color: #555;
  margin-bottom: 1rem;
`;

export default function Subscribe() {
  return (
    <Card>
      <Heading>Skroop Subscription</Heading>
      <Subtext>
        <p>Manage your subscription & billing preferences directly with Stripe.</p>
        <br />
        <p>Click the button below.</p>
        <p>Stripe will email you a login link to the payment dashboard.</p>
      </Subtext>
      <a
        href="https://billing.stripe.com/p/login/cNi8wP1LCbtGa5Q36Zco000"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "inline-block",
          backgroundColor: "#2563eb",
          color: "white",
          padding: "0.6rem 1.2rem",
          borderRadius: "6px",
          textDecoration: "none",
          fontWeight: 500,
        }}
      >
        Take me to Stripe
      </a>
    </Card>
  );
}